/**
物料信息
*/

<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>物料信息</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.filename" placeholder="请输入关键词"></el-input>
      </el-form-item>
      <el-select v-model="formInline.status" placeholder="请选择订单状态">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-form-item label="接收时间：">
        <el-date-picker
          v-model="formInline.date"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>

      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="warning" icon="el-icon-export" @click="exportExcels">导出excel</el-button>
        <el-button size="small" type="primary" icon="el-icon-delete" @click="del" v-show="user.principal=='sysadmin'">删除</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" @selection-change="selectChange" :data="listData" highlight-current-row v-loading="loading"
              border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>

      <el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50px">
        <el-table-column align="center" prop="skuid" label="SKUID">
        </el-table-column>
      </el-table-column>
      <el-table-column align="center" prop="mati_SET_NAME" label="物料套装名称">
      </el-table-column>
      <el-table-column align="center" prop="package_NO" label="箱号">
      </el-table-column>
      <el-table-column align="center" prop="qrcode_TEXT" label="二维码昵称">
      </el-table-column>


      <el-table-column align="center" prop="sn" label="SN">
      </el-table-column>
<!--      <el-table-column align="center" prop="logistics_CODE" label="物流商编码">-->
<!--      </el-table-column>-->

      <el-table-column align="center" prop="mati_NAME" label="采购品名">
      </el-table-column>

      <el-table-column align="center" prop="detail_GUID" label="批次号-明细ID" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column align="center" prop="order_NO" label="交付需求单单号">
      </el-table-column>
      <el-table-column align="center" prop="custom_ORDER_NO" label="客户订单号">
      </el-table-column>


      <el-table-column align="center" prop="mati_DESCRIPTION" label="描述" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column align="center" prop="quantity" label="数量">
      </el-table-column>
      <el-table-column align="center" prop="unit" label="单位">
      </el-table-column>

      <el-table-column align="center" prop="hope_DELIVER_DATE" label="期望收货日期">
        <div slot-scope="scope">
          {{scope.row.createtime|timestampToTime}}
        </div>
      </el-table-column>
      <el-table-column align="center" prop="qr_IMG" label="二维码图片" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column align="center" prop="customized_FLAG" label="是否定制品">
      </el-table-column>


      <el-table-column align="center" prop="logistics_STORE_NO" label="物流商库房号">
      </el-table-column>
      <el-table-column align="center" prop="order_TYPE" label="交付需求单类型">
      </el-table-column>

      <el-table-column align="center" prop="in_STORE_BATCH_NO" label="入库批次号">
      </el-table-column>
      <el-table-column align="center" prop="order_DATE" label="下单日期">
        <div slot-scope="scope">
          {{scope.row.createtime|timestampToTime}}
        </div>
      </el-table-column>


        <el-table-column align="center" prop="createtime" label="接收时间">
          <div slot-scope="scope">
                {{scope.row.createtime|timestampToTime}}
          </div>

        </el-table-column>


        <el-table-column align="center" prop="status" label="订单状态">

          <!--      <span v-if="new Date()-Date.parse(scope.row.updatetime)>60*60*1000" style="color: red;">
                     合成失败
                    </span>
               <span v-else>-->

          <orderStatus slot-scope="scope">
                   <span v-if="new Date()-Date.parse(scope.row.updatetime)>60*60*1000&&scope.row.status==-1">
                   合成失败
                  </span>
            <span v-else>
                    {{scope.row.status|OrderStatus}}
                 </span>
          </orderStatus>
        </el-table-column>
      <el-table-column align="center" prop="batchNumber" label="批次">
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>


  </div>
</template>

<script>
  import {
    compose,
    getOrderListAll,
    del,
    exportExcel

  } from '../../api/ordersMG'
  import Pagination from '../../components/Pagination'

  export default {
    name: "orders",
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        formInline: {
          date: [],
          filename: "",
          status: "",
          pageNum: 1,
          pageSize: 10
        },
        date: '',
        selectdata: [],
        listData: [], //用户数据

        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        options: [{
          value: '99',
          label: '全部'
        }, {
          value: '-1',
          label: '合成失败/正在合成'
        }, {
          value: '0',
          label: '待合成'
        }, {
          value: '1',
          label: '待发货'
        }, {
          value: '2',
          label: '已发货'
        }],
        status: '99'
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
      this.user = JSON.parse(localStorage.getItem('userdata'))
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 选择复选框事件
      selectChange(val) {
        this.selectdata = val
      },

      // 获取订单列表
      getdata(parameter) {
        this.loading = true


        /***
         * 调用接口，注释上面模拟数据 取消下面注释
         */
        getOrderListAll(parameter)
          .then(res => {
            this.loading = false
            if (res.code != 0) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.data
              // 分页赋值
              this.pageparm.currentPage = this.formInline.pageNum
              this.pageparm.pageSize = this.formInline.pageSize
              this.pageparm.total = res.count
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('数据加载失败，请稍后再试！')
          })

      },
      exportExcels() {
        // let params="filename="+this.formInline.filename+"&status="+this.formInline.status+"&date="+this.formInline.date
        //
        // window.open( "/api/export?" + params)



         this.exportExcel(this.formInline)

      },
//导出excel
      exportExcel(parameter) {

        //let params="filename="+this.formInline.filename+"&status="+this.formInline.status+"&date="+this.formInline.date
        exportExcel(parameter)
          .then(res => {

            const link = document.createElement("a");
            const blob = new Blob([res], {
              type: "application/vnd.ms-excel;charset=utf-8",

            });

            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", `物料信息.xls`);
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);

          })
          .catch(err => {
            this.loading = false
            this.$message.error('导出失败，请稍后再试！')
          })

      },

       del()
      {

        let len = this.selectdata
        if (len == 0) {
          this.$message({
            type: 'warning',
            message: "请选择需要删除数据"
          })
          return
        }

        let params = {
          ids: ''
        }
        let idlist = []
        if (len != 0) {
          for (let i = 0; i < len.length; i++) {
            idlist.push(len[i].id)
          }
        }

        params.ids = idlist.join(',')

        this.loading = true
        del(params)
          .then(res => {
            this.loading = false
            if (res.code != 0) {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            } else {
              this.search();
              this.$message({
                type: 'info',
                message: "操作成功"
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('未知错误！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.pageNum = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline)
      }
      ,
      stautsFormat(row, column) {

        if (row.status === 0) {
          return '待合成'
        } else if (row.status === 1) {
          return '已合成'
        } else if (row.status === -1) {
          return '正在合成'
        }else if (row.status === 2) {
          return '已发货'
        }
      }
      , createpdf() {

        let len = this.selectdata
        if (len == 0) {
          this.$message({
            type: 'warning',
            message: "请选择需要待合成数据"
          })
          return
        }
        let params = {
          ids: ''
        }
        let idlist = []
        if (len != 0) {
          for (let i = 0; i < len.length; i++) {
            idlist.push(len[i].id)
          }
        }

        params.ids = idlist.join(',')

        this.loading = true
        compose(params)
          .then(res => {
            this.loading = false
            //
            // if(res=="没有通过权限验证！")
            // {
            //   this.$message({
            //     type: 'error',
            //     message: res
            //   })
            //   return;
            // }
            if (res.code != 0) {

              this.$message({
                type: 'warning',
                message: res.msg
              })
            } else {
              this.search();
              this.$message({
                type: 'info',
                message: "操作成功"
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('未知错误！')
          })
      }

    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/views/orders/OrderDetails.vue